import script from "./SummaryWeb.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryWeb.vue?vue&type=script&setup=true&lang=js"

import "./SummaryWeb.vue?vue&type=style&index=0&id=6ef6f5ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef6f5ae"]])

export default __exports__